import useYWR, { YWRKey } from "@/features/ui/hooks/use-ywr";
import useFetcher from "@/utils/use-fetcher";
import { calcUrl } from "@/features/ui/helpers/fetcher-helpers";
import { ConditionType } from "@/features/order-sheets/order-sheet.type";

// (부티크) 통합 주문 상품 화면에서 오더 한 건의 확정 수량을 저장한다.
// 부티크 오더시트 화면의 저장과 같게 처리된다(오더시트 새 리비전).

export interface ConfirmBoutiqueOrderSheetQuantitiesRequest {
  options: {
    orderSheetId: number;
    productOptionId: number;
    confirmedQuantity: number;
  }[];
  // 확정 가격조정을 바꾼 상품만. 확정 단가는 서버가 오더시트 화면과 같은 식으로 다시 계산한다.
  prices: {
    orderSheetId: number;
    productId: number;
    by: ConditionType;
    value: number;
  }[];
}

export interface ConfirmBoutiqueOrderSheetQuantitiesPathParameter {
  boutiqueId: number;
  lineSheetSetId: number;
  orderSheetSetId: number;
}

const confirmOrderSheetQuantitiesKey: YWRKey<ConfirmBoutiqueOrderSheetQuantitiesPathParameter> =
  {
    url: (parameter) =>
      calcUrl(
        "/boutiques/:boutiqueId/pathpick/line-sheet-sets/:lineSheetSetId/order-sheet-sets/:orderSheetSetId/confirm-quantities",
        parameter
      ),
    method: "put",
  };

export function useConfirmBoutiqueOrderSheetQuantities() {
  const fetcher = useFetcher<
    ConfirmBoutiqueOrderSheetQuantitiesRequest,
    unknown
  >();
  return useYWR(confirmOrderSheetQuantitiesKey, fetcher);
}
